module.exports = __webpack_public_path__ + "9cb1a34e2455827bcc67889d44c01886.jpg";